import { logger as baseLogger } from '@/logger'
import { logLevel } from '@/logger/constants'

export const createFeatureLogger = (feature: string, context?: Record<string, any>) => {
    const logger = baseLogger
        .child()
        .withContext({ ...context, tags: { ...context?.tags, feature } })

    logger.setLevel(logLevel)

    return logger
}
